import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

/**
 * Request/response shapes for PUT /api/exp/sites/{siteLuid}/settings, which is
 * served by RestApiSiteSettingsController#updateSiteSettings in the monolith.
 *
 * The controller deserializes the body into `TsRequest`, reading the
 * `siteSetting` list of {key, value} pairs and forwarding registry-driven
 * settings to ISiteSettingsUpdater.setMap.
 */

export interface ISiteSettingPair {
  key: string;
  value: string;
}

export interface IUpdateSiteSettingsRequest {
  siteSetting: ISiteSettingPair[];
}

export interface IUpdateSiteSettingsResponse {
  siteSetting?: ISiteSettingPair[];
}

function updateSiteSettingsConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: 'exp',
    httpMethod: 'PUT',
    endpoint: 'settings',
  };
}

export class UpdateSiteSettingsService {
  /**
   * Send a sparse list of {key, value} updates to the V2 site settings
   * REST endpoint. `value` is always a string; coerce booleans/numbers
   * before calling.
   */
  public static updateSiteSettings(
    settings: ISiteSettingPair[]
  ): Promise<IUpdateSiteSettingsResponse> {
    return makeJsonRestApiRequest<IUpdateSiteSettingsRequest, IUpdateSiteSettingsResponse>({
      config: updateSiteSettingsConfig(),
      request: { siteSetting: settings },
    });
  }
}
